<!-- Login Component - Modern Bootstrap 5.3.7 -->
<div class="container-fluid py-4">
  <div class="row justify-content-center">
    <div class="col-12 col-sm-8 col-md-6 col-lg-5 col-xl-4">
      
      <!-- Login Card -->
      <div class="card shadow-lg border-0 login-card">
        <div class="card-body p-4 p-md-5">
          
          <!-- Header -->
          <div class="text-center mb-4">
            <div class="login-icon mb-3">
              <i class="fa fa-user-circle fa-3x text-primary"></i>
            </div>
            <h2 class="card-title fw-bold text-dark mb-1">
              {{ 'LOGIN.TITLE' | translate }}
            </h2>
            <p class="text-muted small">
              {{ 'LOGIN.SUBTITLE' | translate }}
            </p>
          </div>
          
          <!-- Login Form -->
          <form [formGroup]="loginForm" (ngSubmit)="login()" novalidate>
            
            <!-- Email Field -->
            <div class="mb-3">
              <label for="username" class="form-label fw-semibold">
                <i class="fa fa-envelope me-2 text-muted"></i>
                {{ 'LOGIN.EMAIL_LABEL' | translate }}
              </label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0">
                  <i class="fa fa-envelope text-muted"></i>
                </span>
                <input 
                  formControlName="username"
                  type="email" 
                  class="form-control border-start-0 ps-0"
                  id="username" 
                  [placeholder]="'LOGIN.EMAIL_PLACEHOLDER' | translate"
                  [class.is-invalid]="loginForm.get('username')?.errors && loginForm.get('username')?.touched"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                  aria-describedby="username-error">
              </div>
              <div 
                id="username-error"
                class="invalid-feedback d-block"
                *ngIf="loginForm.get('username')?.touched && loginForm.get('username')?.hasError('required')">
                <i class="fa fa-exclamation-circle me-1"></i>
                {{ 'LOGIN.EMAIL_REQUIRED' | translate }}
              </div>
            </div>
            
            <!-- Password Field -->
            <div class="mb-4">
              <label for="password" class="form-label fw-semibold">
                <i class="fa fa-lock me-2 text-muted"></i>
                {{ 'LOGIN.PASSWORD_LABEL' | translate }}
              </label>
              <div class="input-group">
                <span class="input-group-text bg-light border-end-0">
                  <i class="fa fa-lock text-muted"></i>
                </span>
                <input 
                  formControlName="password"
                  [type]="showPassword ? 'text' : 'password'" 
                  class="form-control border-start-0 ps-0"
                  id="password" 
                  [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate"
                  [class.is-invalid]="loginForm.get('password')?.errors && loginForm.get('password')?.touched"
                  autocomplete="off"
                  readonly
                  onfocus="this.removeAttribute('readonly');"
                  aria-describedby="password-error">
                <span class="input-group-text bg-light border-start-0" style="cursor:pointer;" (click)="showPassword = !showPassword">
                  <i class="fa" [ngClass]="showPassword ? 'fa-eye-slash' : 'fa-eye'"></i>
                </span>
              </div>
              <div 
                id="password-error"
                class="invalid-feedback d-block"
                *ngIf="loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched">
                <i class="fa fa-exclamation-circle me-1"></i>
                {{ 'LOGIN.PASSWORD_REQUIRED' | translate }}
              </div>
            </div>

            <!-- Login Button -->
            <div class="d-grid gap-2 mb-3">
              <button 
                type="submit" 
                class="btn btn-primary btn-lg fw-semibold"
                [disabled]="!loginForm.valid || processing"
                [attr.aria-label]="'LOGIN.LOGIN_BUTTON' | translate">
                <span *ngIf="processing" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                <i *ngIf="!processing" class="fa fa-sign-in me-2"></i>
                {{ 'LOGIN.LOGIN_BUTTON' | translate }}
              </button>
            </div>
            
            <!-- Help Links -->
            <div class="text-center">
              <div class="d-flex justify-content-center align-items-center gap-3 flex-wrap">
                <a 
                  [routerLink]="['/login-help']"
                  class="text-decoration-none fw-semibold text-primary"
                  [attr.aria-label]="'LOGIN.FORGOT_PASSWORD' | translate">
                  <i class="fa fa-question-circle me-1"></i>
                  {{ 'LOGIN.FORGOT_PASSWORD' | translate }}
                </a>
                <span class="text-muted">|</span>
                <a 
                  [routerLink]="['/contact-us']"
                  class="text-decoration-none fw-semibold text-secondary"
                  [attr.aria-label]="'LOGIN.NEED_HELP' | translate">
                  <i class="fa fa-life-ring me-1"></i>
                  {{ 'LOGIN.NEED_HELP' | translate }}
                </a>
              </div>
            </div>
            
          </form>
          
          <!-- Register Link -->
          <hr class="my-4">
          <div class="text-center">
            <p class="mb-2 text-muted small">{{ 'LOGIN.NO_ACCOUNT' | translate }}</p>
            <a 
              [routerLink]="['/register']"
              class="btn btn-outline-secondary fw-semibold"
              [attr.aria-label]="'LOGIN.CREATE_ACCOUNT' | translate">
              <i class="fa fa-user-plus me-2"></i>
              {{ 'LOGIN.CREATE_ACCOUNT' | translate }}
            </a>
          </div>
          
        </div>
      </div>
      
    </div>
  </div>
</div>
